import { onMounted, ref, onUnmounted } from '@nuxtjs/composition-api'

export function usePDPNavigationObserver(callback: () => void) {
  const targetReference = ref()
  let observer: IntersectionObserver
  onMounted(() => {
    observer = new IntersectionObserver(
      (entries: any) => {
        if (entries[0].isIntersecting) {
          callback()
        }
      },
      {
        rootMargin: '-23% 0% -76% 0%',
      }
    )
    // Needs to be here, because Navigation is sometimes not visible and targetReference is then undefined
    // and sometimes $el is instanceof Comment and that can not be passed to observer
    if (targetReference.value && !(targetReference.value.$el instanceof Comment)) {
      observer.observe(targetReference.value?._isVue ? targetReference.value.$el : targetReference.value)
    }
  })

  onUnmounted(() => {
    observer.disconnect()
  })

  return targetReference
}
